import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./context/I18nContext";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";

import Splash from "./pages/Splash";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Paywall from "./pages/Paywall";
import PaymentSuccess from "./pages/PaymentSuccess";
import Vote from "./pages/Vote";
import Question from "./pages/Question";
import Results from "./pages/Results";
import Dashboard from "./pages/Dashboard";
import Legal from "./pages/Legal";
import Admin from "./pages/Admin";
import AdminRecover from "./pages/AdminRecover";
import Discussion from "./pages/Discussion";
import Welcome from "./pages/Welcome";
import Security from "./pages/Security";
import IosComingSoonBanner from "./components/IosComingSoonBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <Navbar />
            <IosComingSoonBanner />
            <Routes>
            <Route path="/" element={<Splash />} />
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/security" element={<Security />} />
            <Route path="/admin-recover" element={<AdminRecover />} />
            <Route
              path="/results"
              element={
                <ProtectedRoute requirePaid>
                  <Results />
                </ProtectedRoute>
              }
            />
            <Route
              path="/discussion"
              element={
                <ProtectedRoute requirePaid>
                  <Discussion />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requirePaid>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/paywall"
              element={
                <ProtectedRoute>
                  <Paywall />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment-success"
              element={
                <ProtectedRoute>
                  <PaymentSuccess />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vote"
              element={
                <ProtectedRoute requirePaid>
                  <Vote />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vote/:qid"
              element={
                <ProtectedRoute requirePaid>
                  <Question />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" />
        </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
